import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { GeneralType } from "../../../../lib/types";
import { GENERAL_TYPE } from "../../../../lib/enums";
import SubMenu from "../../../Menu/SubMenu";
import PlannerContent from "./PlannerContent";

const mapStateToProps = (state: any) => ({
  mana: (state.governorate.resources.mana || 0),
  magicEnergy: (state.governorate.resources.magicEnergy || 0),
  spells: state.governorate.spells,
  spellCastLimit: state.governorate.spellCastLimit,
  magicCore: state.governorate.magicCore,
  magicClosed: state.governorate.magicClosed,
  magicMode: state.governorate.magicMode,
  magicModeAftermath: state.governorate.magicModeAftermath,
  readyToMagic: state.governorate.readyToMagic,
  alliance: state.governorate.alliance,
  mageGeneral: state.governorate.generals
    .find((g: GeneralType) => g.typeId === GENERAL_TYPE.MAGE).general,
  opponent: state.governorate.opponent,
  war: state.governorate.war
});

const connector = connect(mapStateToProps);

const MagicPlanner = ({
  mana,
  magicEnergy,
  spells,
  spellCastLimit,
  magicCore,
  magicClosed,
  magicMode,
  magicModeAftermath,
  mageGeneral,
  readyToMagic,
  alliance,
  opponent,
  war
}: ConnectedProps<typeof connector>) => {
  const castBlockMessage = (!mageGeneral && "You need mage general to cast the spells.")
    || (!readyToMagic && "You have to be in 8th turn to cast spells outside of governorate.")
    || (!alliance && "Only members of alliances can cast spells out of own governorate.");

  return (
    <>
      <SubMenu
        tabs={[
          {
            name: "Magic",
            title: "Magic",
            icon: "magie",
            label: "Selfcast",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "MagicPlanner",
            title: "Magic",
            icon: "magie",
            label: "Planner",
            active: true,
            parameters: {
              reload: false
            }
          },
          {
            name: "MagicEmperorTent",
            title: "Magic",
            icon: "magie",
            label: "Emperor Tent",
            active: false,
            parameters: {
              reload: true
            }
          }
        ]}
      />

      <section className="boxes-group planner">
        <PlannerContent
          castBlockMessage={castBlockMessage}
          mana={mana}
          magicEnergy={magicEnergy}
          mageGeneral={mageGeneral}
          spells={spells}
          spellCastLimit={spellCastLimit}
          magicClosed={magicClosed}
          magicCore={magicCore}
          magicMode={magicMode}
          magicModeAftermath={magicModeAftermath}
          readyToMagic={readyToMagic}
          alliance={alliance}
          war={war}
          opponent={opponent}
        />
      </section>
    </>
  )
}

export default connector(MagicPlanner);
